import Empty from 'constants/empty';
import LanguageLocale from 'utils/LanguageLocale';

/**
 * Returns true if a feature flag is enabled globally and for the given country.
 */
const isFeatureEnabled = (flagConfig = {}, country) => !!(flagConfig.isEnabled && flagConfig[`isEnabled${country}`]);

/**
 * Returns resolved feature flags for AutoReplenishment from Sephora configuration.
 * Reads Sephora.configurationSettings once — safe to call outside React lifecycle.
 */
export const getFeatureFlags = () => {
    const config = Sephora.configurationSettings || Empty.Object;
    const arConfig = config.autoReplenishmentConfigurations || Empty.Object;
    const country = LanguageLocale.getCurrentCountry();

    const isChangeAddressEnabled = !!(
        arConfig.enableReplenishmentAddressModifiable && arConfig[`enableReplenishmentAddressModifiable_${country}`]?.isEnabled
    );

    return {
        isAutoReplenishEmptyHubEnabled: !!config.isAutoReplenishEmptyHubEnabled,
        isChangeAddressEnabled: isChangeAddressEnabled,
        isChangeDateEnabled: isFeatureEnabled(arConfig.changeDate, country),
        isChangeFrequencyEnabled: !!arConfig.enableReplenishmentFrequencyModifiable,
        isChangePaymentEnabled: !!arConfig.enableReplenishmentPaymentModifiable,
        isFlexIncentivesEnabled: isFeatureEnabled(arConfig.flexIncentives, country),
        isOrderNowEnabled: isFeatureEnabled(arConfig.getItNow, country),
        isSkipPauseEnabled: !!arConfig.enableReplenishmentOperations,
        isSkuSwapEnabled: isFeatureEnabled(arConfig.skuSwap, country)
    };
};
